<template>
  <!-- Único punto de la plataforma autorizado para usar v-html (SEC-6):
       todo contenido pasa por DOMPurify antes de insertarse al DOM. -->
  <!-- eslint-disable-next-line vue/no-v-html -- sink central sanitizado (SEC-6) -->
  <div v-html="sanitized_content" class="rich-text-content"></div>
</template>

<script>
import { sanitizeRichText } from "@/utils/sanitizer";

export default {
  name: "RenderVHtml",
  props: {
    content: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    sanitized_content() {
      return sanitizeRichText(this.content);
    },
  },
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.rich-text-content {
  padding: 0.4em 0.5em;
}
</style>